function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: white;\r\n        stroke-linecap: round;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: white;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Search_Grey",
  "data-name": "Search Grey",
  transform: "translate(-277.788 -1136.321) rotate(45)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_15",
  "data-name": "Path 15",
  className: "cls-1",
  transform: "translate(1012 595)"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M12.074,0A12.074,12.074,0,1,1,0,12.074,12.074,12.074,0,0,1,12.074,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M 12.07396030426025 3 C 7.070560455322266 3 3 7.070560455322266 3 12.07396030426025 C 3 17.07736015319824 7.070560455322266 21.14792060852051 12.07396030426025 21.14792060852051 C 17.07736015319824 21.14792060852051 21.14792060852051 17.07736015319824 21.14792060852051 12.07396030426025 C 21.14792060852051 7.070560455322266 17.07736015319824 3 12.07396030426025 3 M 12.07396030426025 0 C 18.74222946166992 0 24.14792060852051 5.405691146850586 24.14792060852051 12.07396030426025 C 24.14792060852051 18.74222946166992 18.74222946166992 24.14792060852051 12.07396030426025 24.14792060852051 C 5.405691146850586 24.14792060852051 0 18.74222946166992 0 12.07396030426025 C 0 5.405691146850586 5.405691146850586 0 12.07396030426025 0 Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  className: "cls-2",
  d: "M7127.6,615h12.074",
  transform: "translate(-6091.694 -7.926)"
}));

var SvgSearchWhite = function SvgSearchWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36.103 36.102",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SearchWhite.b09a5a0b.svg";
export { ForwardRef as ReactComponent };